import type { SerializedStyles } from '@emotion/react';
import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';

import type { AppTheme } from '@app/styles/theme';
import { rem } from '@app/styles/theme/layout';

import type { AlertType } from './Alert.constants';
import { AlertLayout } from './Alert.constants';

export const Container = styled.div`
  display: flex;
  align-items: center;
  border-color: currentColor;
  border-style: solid;
  border-width: 1px;
  border-radius: ${({ theme }) => theme.radii.normal};
  padding: ${rem(16)} ${rem(13)};
  line-height: 1.5;

  & > svg {
    width: ${rem(25)};
    height: ${rem(24)};
    margin-right: ${rem(13)};
  }

  a {
    color: ${({ theme }) => theme.colors.black};
    text-decoration: underline;
  }
`;

export const ActionsContainer = styled.div<{ layout: AlertLayout }>`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: center;
  margin: ${({ layout }) => rem(layout === AlertLayout.Column ? 12 : 0)} 0 0
    ${({ layout }) => rem(layout === AlertLayout.Row ? 12 : 0)};

  & > *:not(:last-child) {
    margin-right: ${rem(12)};
  }
`;

export const getAlertStyles = (
  theme: AppTheme,
  type: AlertType,
  shouldShake: boolean,
): SerializedStyles => {
  switch (type) {
    case 'info':
      return css`
        color: ${theme.colors.info};
        background-color: ${theme.colors.infoBackground};
        border-color: ${theme.colors.infoBorder};
        ${shouldShake ? headshakeAnimation : ''}
      `;
    case 'success':
      return css`
        color: ${theme.colors.success};
        background-color: ${theme.colors.successBackground};
        ${shouldShake ? headshakeAnimation : ''}
      `;
    case 'warning':
      return css`
        color: ${theme.colors.warning};
        background-color: ${theme.colors.warningBackground};
        ${shouldShake ? headshakeAnimation : ''}
      `;
    case 'error':
      return css`
        color: ${theme.colors.error};
        background-color: ${theme.colors.errorBackground};
        ${shouldShake ? headshakeAnimation : ''}
      `;
    default:
      return css``;
  }
};

const headShake = keyframes`
  0% {
    transform: translateX(0);
  }

  6.5% {
    transform: translateX(-6px) rotateY(-9deg);
  }

  18.5% {
    transform: translateX(5px) rotateY(7deg);
  }

  31.5% {
    transform: translateX(-3px) rotateY(-5deg);
  }

  43.5% {
    transform: translateX(2px) rotateY(3deg);
  }

  50% {
    transform: translateX(0);
  }
`;

const headshakeAnimation = css`
  animation: ${headShake} 1s ease-in-out;
`;
